export function getYearOptionsForAntSelect(
  numberOfPreviousYears: number = 5,
  numberOfNextYears: number = 5
) {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (
    let i = currentYear - numberOfPreviousYears;
    i <= currentYear + numberOfNextYears;
    i++
  ) {
    years.push({ label: i.toString(), value: i });
  }

  return years;
}

export function getInOfficeHours(seconds: number = 0) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (!seconds) {
    return "00:00"; 
  }

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}

export function secondsToTime(seconds: number): string {
  seconds = seconds % (24 * 3600);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
}

export const formatDate = (timestamp: number): string => {
  if (timestamp === null) return "";
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  return `${year}.${month}.${day} ${hour}:${minute}`;
};
